import { STORE_NAME } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IThinkAnalyticsService } from '@intigral/domain/lib/application/services/ThinkAnalyticsService';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import h, { getCountry } from '../../helpers/common';
import { getUserInfo } from '../../utils/user';
import { taFeedQueryKeys } from './taFeedQueryKeys';

const fetchTaFeed = async (carousel: Carousel) => {
    try {
        const user = getUserInfo();
        const carouselDataSource = carousel.dataSources?.[0] ?? '';
        const carouselNewType = carousel.newType ?? '';
        const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
        const selectedProfile = get(STORE_NAME.SELECTED_PROFILE);
        const profileName = selectedProfile?.profileName;
        const rating = selectedProfile?.newParentalControl || selectedProfile?.parentalControl;
        const params: Record<string, string | string[]> = {
            userName: user.username,
            device: h.getDevice(),
            profileName,
            country: getCountry(),
            rating,
            subGuids: user.subscriptionGUID,
        };
        const feedResponse = await taService.getTAByUsecaseId(
            carouselDataSource,
            user.apiKey,
            user.identityToken,
            params
        );
        const newData = {
            entries: feedResponse?.data?.entries.map((item) => {
                return {
                    ...item,
                    useCaseId: feedResponse?.data?.refId,
                };
            }),
            ...feedResponse.data,
        };
        return newData;
    } catch (error) {
        return { entries: [] };
    }
};

export const useTaFeed = (carousel: Carousel | undefined, options?: { enabled?: boolean }) => {
    const location = useLocation();
    const enabled = (options?.enabled ?? true) && !!carousel;
    return useQuery({
        queryKey: carousel
            ? taFeedQueryKeys.carousel(carousel, location.search)
            : (['taFeed', 'disabled'] as const),
        queryFn: () => fetchTaFeed(carousel as Carousel),
        staleTime: 10 * 60 * 1000, // Consider data stale after 10 minutes
        enabled,
        //cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
    });
};
